function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChannel = function SvgChannel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.18 5a34.73 34.73 0 0 1 6.07.41 2.3 2.3 0 0 1 1.41 1.77A31.94 31.94 0 0 1 20 12a31.83 31.83 0 0 1-.34 4.81 2.3 2.3 0 0 1-1.41 1.77C17 19 12 19 12 19s-5 0-6.25-.42a2.33 2.33 0 0 1-1.42-1.77A29.71 29.71 0 0 1 4 12.17v-.33a29.71 29.71 0 0 1 .33-4.65 2.33 2.33 0 0 1 1.42-1.77A34.6 34.6 0 0 1 11.82 5ZM10 9v6l5-3Z",
    style: {
      fillRule: "evenodd"
    },
    "data-name": "Ds Channel-Copy"
  })));
};
export default SvgChannel;